import * as React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {
  Col,
  Row,
  FormGroup,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  InputGroup,
  FormFeedback,
  FormText,
} from "reactstrap";
import InputLabel from "@mui/material/InputLabel";
import Popover from "./Popover";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const { CIS_NUMBER, ValUD, status, selected, itemgroupselected, backup, platform } =
    props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  var cis_no = CIS_NUMBER;
  const [databackup, setDatabackup] = React.useState(false);
  const [userdata, setUserdata] = React.useState([]);
  const [assignuserdata, setAssignuserdata] = React.useState([]);
  const [newstate, setNewstate] = React.useState([]);

  const IndualClickOpen = (e) => {
    e.preventDefault();
    if (userdata.length === 0) {
      const auditID = window.sessionStorage.getItem("auditID");
      const Keyvalue = `${auditID}-${cis_no}`;
      fetch(
        `${process.env.REACT_APP_API_URL}/api/hostIndividualUserdata/${Keyvalue}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
        }
      )
        .then((resp) => resp.json())
        .then((resp) => {
          setUserdata(resp);
          resp.map((userdata) => {
            setNewstate((prevState) => ({
              ...prevState,
              [userdata.variable]: userdata.output,
            }));
            setAssignuserdata((prevState) => ({
              ...prevState,
              [userdata.variable]: userdata.output,
            }));
          });
        })
        .catch((error) => {
          console.error(error);
        });
      userdata.map((userdata) => {
        setNewstate((prevState) => ({
          ...prevState,
          [userdata.variable]: userdata.output,
        }));
        setAssignuserdata((prevState) => ({
          ...prevState,
          [userdata.variable]: userdata.output,
        }));
      });
    }
    if (backup === "yes") {
      setDatabackup(true);
    }
    handleClickOpen();
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setNewstate((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    setAssignuserdata((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const IndualSubmit = (selected) => (e) => {
    e.preventDefault();
    var value1 = JSON.stringify(newstate);
    var backupdata;
    if (databackup) {
      backupdata = "yes";
    } else {
      backupdata = "no";
    }

    let sub = {
      host_id: window.sessionStorage.getItem("hostID").toString(),
      audit_id: window.sessionStorage.getItem("auditID").toString(),
      tags: selected.toString(),
      user_data: value1,
      backup_data: backupdata,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/run_remedy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.detail);
        window.localStorage.setItem("remedy_run_limit", data.detail);
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
        window.location.href = "/admin/remedy";
      })
      .catch((error) => {
        console.log(error);
        window.location.href = "/admin/remedy";
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      });
    setOpen(false);
  };

  const handleChangecheck = (event) => {
    setDatabackup(event.target.checked);
  };
  return (
    <>
      <div>
      {platform === 'aws' || platform === 'azure' || platform === 'gcp' ? (
        <React.Fragment>
          <span 
          // style={{
          //   backgroundColor: "tomat"
          // }}
          style={{ color: '#ff6347'}}
          className="font-bold uppercase"
          >
            FAILED
          </span>          
        </React.Fragment>
      ) : (
        <React.Fragment>        
        {status === "FAILED" ? (
          <button
            disabled={
              ValUD === "yes" ||
              selected.length > 0 ||
              itemgroupselected.length > 0
                ? true
                : false
            }
            className={
              ValUD === "yes" ||
              selected.length > 0 ||
              itemgroupselected.length > 0
                ? "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                : [
                    status === "FAILED"
                      ? "bg-red-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      : status === "FIXED"
                      ? "bg-emerald-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150",
                  ]
            }
            type="button"
            onClick={IndualClickOpen}
          >
            {status === "FAILED" ? "FIX IT" : status === "FIXED" ? "FIXED" : ""}
          </button>
        ) : (
          <button
            disabled
            className="bg-emerald-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
          >
            FIXED
          </button>
        )}
        </React.Fragment>
        )}
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            USER DATA
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Form>
              <Drawer />
              {userdata.length === 0 ? (
                ""
              ) : (
                <React.Fragment>
                  {userdata.map((field) => {
                    return (
                      <React.Fragment>
                        <InputLabel
                          style={{ fontSize: "small" }}
                          htmlFor="component-simple"
                        >
                          {" "}
                          {field.name} <Popover hint={field.hint} />
                        </InputLabel>
                        <TextField
                          id={field.variable}
                          value={newstate[field.variable]}
                          onChange={handleChange}
                          type={field.type}
                          fullWidth
                          size="medium"
                        />
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              )}
            </Form>
            <Grid container spacing={0}>
              <Grid item xs={1}>
                <Checkbox
                  checked={databackup}
                  onChange={handleChangecheck}
                  value="true"
                />
              </Grid>
              <Grid item xs={11}>
                <Typography gutterBottom>
                  I agree that i have backup of the Server before running this
                  Remedy, so that I will be able to restore the server if the
                  remediation makes the server unusable.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <button
              className="font-bold outline uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none "
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              disabled={databackup ? false : true}
              className={
                databackup
                  ? "bg-red-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              }
              type="button"
              onClick={IndualSubmit(cis_no)}
            >
              <Link to="/admin/remedy">FIX IT</Link>
            </button>
          </DialogActions>
        </BootstrapDialog>
      </div>
    </>
  );
}